<template>
  <div id="app">
    <Header />
    <LeftSideBar />
    <router-view />
    <Footer />
    <notifications group="foo" />
  </div>
</template>
<script>
import Header from "./components/layout/Header/Header";
import Footer from "./components/layout/Footer";
import LeftSideBar from "./components/layout/LeftSideBar/LeftSideBar";
import env from "./components/common/env";
export default {
  name: "app",
  components: {
    Header,
    LeftSideBar,
    Footer,
  },
};
document.title = `S.O.S TRUCK ${env.env !== "prod" ? `(${env.env})` : ""}`;
</script>

<style>
</style>
